/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { ClaimPaymentResponseDto } from './ClaimPaymentResponseDto';
import {
    ClaimPaymentResponseDtoFromJSON,
    ClaimPaymentResponseDtoFromJSONTyped,
    ClaimPaymentResponseDtoToJSON,
    ClaimPaymentResponseDtoToJSONTyped,
} from './ClaimPaymentResponseDto';

/**
 * 
 * @export
 * @interface ClaimPaymentPaginationResponseDto
 */
export interface ClaimPaymentPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ClaimPaymentPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ClaimPaymentResponseDto>}
     * @memberof ClaimPaymentPaginationResponseDto
     */
    items: Array<ClaimPaymentResponseDto>;
}

/**
 * Check if a given object implements the ClaimPaymentPaginationResponseDto interface.
 */
export function instanceOfClaimPaymentPaginationResponseDto(value: object): value is ClaimPaymentPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ClaimPaymentPaginationResponseDtoFromJSON(json: any): ClaimPaymentPaginationResponseDto {
    return ClaimPaymentPaginationResponseDtoFromJSONTyped(json, false);
}

export function ClaimPaymentPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPaymentPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ClaimPaymentResponseDtoFromJSON)),
    };
}

export function ClaimPaymentPaginationResponseDtoToJSON(json: any): ClaimPaymentPaginationResponseDto {
    return ClaimPaymentPaginationResponseDtoToJSONTyped(json, false);
}

export function ClaimPaymentPaginationResponseDtoToJSONTyped(value?: ClaimPaymentPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ClaimPaymentResponseDtoToJSON)),
    };
}

